module.exports = __webpack_public_path__ + "static/img/diceng_coovally@3x.1b4479ef.png";